import api from "../services/api";
// import globalToast from "../components/common/globalToast";

const service_path = '/financial_report.php';

// export function printOrderProof(data) {

//     const payload = {
//         customer_id: data.customer_id,
//         total_price: data.total_price,
//         payment_methods: data.payment_methods?.map(pm => ({
//             name: pm.name,
//             price: pm.price
//         })),
//         attendant_name: data.attendant_name,
//         products: data.products?.map(prod => ({
//             name: prod.name,
//             is_crafted: prod.is_crafted,
//             selected_metal: prod.selected_metal,
//             selected_metal_name: prod.selected_metal_name,
//             public_description: prod.public_description,
//             size_one: prod.size_one,
//             engraving_one: prod.engraving_one,
//             size_two: prod.size_two,
//             engraving_two: prod.engraving_two,
//             stones: prod.stones?.map(stone => ({
//                 stone_name: stone.stone_name,
//                 variation_name: stone.variation_name,
//                 price: stone.price,
//                 quantity: stone.quantity,
//                 observation: stone.observation
//             })),
//             extras: prod.extras?.map(extra => ({
//                 name: extra.name,
//                 price: extra.price
//             })),
//             self_reference: prod.self_reference,
//             price: prod.price,
//             is_service: prod.is_service,
//             delivery_date: prod.delivery_date
//         }))
//     };

//     console.log("Payload para impressão do comprovante:", payload);

//     // Aqui você pode fazer a requisição para o serviço de impressão, por exemplo:
//     axios.post('http://localhost:5000/print-production', payload)
//         .then(response => {
//             const { data } = response;
//             globalToast.success(data.message);
//         })
//         .catch(error => {
//             console.log(error);
//             globalToast.error('Impressora indisponível no momento.');
//         });
// }

export function getFinancialReports(filters = {}) {
    // Remove filtros vazios antes de enviar
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;
    
    const response = api.get(url);

    return response;
};

export function getOrderDetails(id) {

    const response = api.get(`${service_path}?id=${id}`);

    return response;
};